export default __webpack_public_path__ + "assets/models/5481ff90ef8d67a37e88a9f5f4302677.glb";